import { Component, OnInit } from '@angular/core';
import { LoginService } from '../login.service';
import { HttpClient } from '@angular/common/http';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    standalone: false
})
export class LoginComponent implements OnInit {

  user: string;
  pw: string;
  error: string;
  code: string;
  hidepw=true;
  typed=false;
  showLogin=false;
  currentDate = new Date();
  currentYear = this.currentDate.getFullYear();

  constructor(public loginService: LoginService,private http: HttpClient) { }

  ngOnInit() {
  }

 checkLogin(){
    // this.loginService.totpVerify = true;
    // Logging in here starts a new app session, possibly as a different user on a shared
    // machine - drop the previous user's search / today-list history.
    this.loginService.resetUserHistory();
    if(! this.loginService.getCode)
    this.loginService.login(this.user,this.pw);
  else
    this.loginService.sendCode(this.code);
  }
  
  clean(){
    try{
      this.user = this.user.replace(/[^\x00-\x7F]+/, '')
      this.pw = this.pw.replace(/[^\x00-\x7F]+/, '')
    }
    catch{}
  }

  setClinic(index:number){
    this.loginService.setClinic(index);
  }
  viewonly(){

  }

}
